<template>
  <div class="yzcd" style="background:rgb(243,243,243)">
    <headbox></headbox>
    <div class="assreboxo">
        <p>当前位置：<span>赢在成都</span><span>&nbsp;>&nbsp;产业成就</span>
        </p>
    </div>
    <div class="searchbox">
      <div class="searl">
        <listleft></listleft>
      </div>
      <div class="seabl">

        <div class="sercont">
          <h1>产业成就</h1>
          <img :src="hfliat.content_img_3" style="width: 80%; margin-left: 10%" alt="" />
          <div class="cont" v-html="hfliat.develop_content"></div>
        </div>
      </div>
    </div>
    <footbox></footbox>
  </div>
</template>
<script>
import headbox from "../components/head.vue";
import footbox from "@/components/footer.vue";
import listleft from "@/components/listleft.vue";

import { detail } from "@/api/index.js";
export default {
  name: "yzcd",
  data() {
    return {
      hfliat: [],
    };
  },
  components: {
    headbox,
    footbox,
    listleft,
  },
  created() {
    this.handleheadfoot();
  },
  methods: {
    // 头部数据
    handleheadfoot() {
      detail(5).then((res) => {
        this.hfliat = JSON.parse(res.data.data.config);
      });
    },
    fn(id) {
      const obj = {
        100: "/cdgk",
        101: "fzhj",
        102: "cycj",
      };
      this.$router.push({ path: obj[id], query: { id } });
    },
  },
};
</script>
<style lang="less" scoped>
.searchbox {
  max-width: 1200px;
  // min-width: 350px;
  margin: 0 auto;
  display: flex;
  text-align: left;
  background: #fff;
  // margin-top: 20px;
}
.searl {
  width:25%;
  padding:20px 20px 0 0;
  @media screen and (max-width:800px) {
    display: none;
  }
}
.seabl {
  width:75%;
  @media screen and (max-width:900px) {
    width:100%;
  }
}
.sertit {
  width: 100%;
  height: 46px;
  line-height: 46px;
  background: #ff9900;
  color: #fff;
  font-size: 24px;
  padding-left: 15px;
}
.searl > ul {
  margin-top: 11px;
}
.searl > ul > li {
  height: 39px;
  padding-left: 15px;
  border-bottom: 1px solid #e4e4e4;
  line-height: 39px;
  font-size: 16px;
  color: #7a7a7a;
}
.searl > ul > li > span {
  float: right;
  color: #e4e4e4;
}
#serlistbox {
  background: #42a5f6;
  color: #fff;
}
.dqwz {
  margin-left: 64px;
}
.dqwz > span {
  color: #ff9900;
}
.sercont {
  margin: 20px 33px 50px 20px;
  @media screen and (max-width: 800px) {
    margin:0px;
    padding: 20px 33px 50px 20px;
  }
}
.sercont > h1 {
  text-align: center;
  margin-bottom: 20px;
  @media screen and (max-width: 900px) {
    text-align: center;
    margin-bottom: 20px;
    font-size: 22px;
  }
  // @media screen and (max-width: 600px) {
  //   font-size: 20px;
  // }
}
.sercont > h4 {
  color: #525252;
  font-size: 16px;
  margin-top: 20px;
}
// .sercont > img {
//   @media screen and (max-width: 900px) {
//     width: 100% !important;
//   }
// }
.cont {
  color: #000;
  font-size: 16px;
  text-indent: 2rem;
}
.seabtnbox {
  margin-top: 30px;
  text-align: center;
}
.seabtnbox > button {
  border: 2px solid #00aaeb;
  color: #00aaeb;
  border-radius: 10pt 10pt 10pt 10pt;
  height: 42px;
  width: 126px;
  font-size: 20px;
  background: #fff;
  margin: 0 auto;
}
.sercont > h4 {
  border-bottom: 1px solid #e1e1e1;
  text-align: center;
}
.sercont > h4 > span {
  margin: 0 5px;
}
@media screen and (max-width: 900px) {
  .searl {
    display: none;
  }
  .searchbox {
    display: block;
  }
  .dqwz {
    margin-left: 15px;
  }
  // .sercont {
  //   margin: 20px 20px 0 20px;
  // }
}
.assreboxo{
  max-width:1200px;
  margin:0 auto;
  font-family: PingFang SC-Regular;
  font-size: 16px;
  background: #fff;
  padding:15px 30px;
  text-align: left;
  @media screen and (max-width:800px){
    display: none;
  }
  }
.assreboxo >p{
  max-width:1200px;
  margin:0 auto;
}
.assreboxo >p >a {
  color: #000;
}
</style>

